import React, { memo, useContext, useEffect, useState } from 'react';
import { Label, Error, CheckBox } from 'components/Form'
import { MenuItem, Chip, createFilterOptions, Typography, Tooltip, SvgIcon, Radio, Box } from '@mui/material'
import { OptionStyles, AutoCompleteStyles, WrapAutocomplete, WrapField, AutoCompleteOptions, WrapFieldContent, WrapMoreOptions, TextFieldStyles } from './Styled'
import { Text, XSSpaceBetween } from 'styles/GlobalStyle';

const SelectOption = (props) => {
    const {
        getTooltip,
        getLabel,
        option,
        selected,
        onClick, // ה-onClick הידני שלך (עבור השנה/סמסטר)
        optionProps, // ה-Props ש-MUI שולח ב-renderOption
        multiple,
        width,
        fullWidth,
        showBlurred,
    } = props;

    // פונקציה למיזוג הלחיצות
    const handleLocalClick = (e) => {
        if (onClick) {
            // אם העברת onClick ידני (כמו ב-SelectSemesterAndYear)
            onClick(option);
        } else if (optionProps && optionProps.onClick) {
            // אם זה ה-Autocomplete הרגיל, נשתמש ב-onClick המקורי של MUI
            optionProps.onClick(e);
        }
    };

    return (
        <Tooltip placement='right' title={getTooltip?.(option) || ""}>
            <OptionStyles
                // 1. חובה לפרוס את כל ה-Props המקוריים של MUI (id, role, tabIndex וכו')
                {...optionProps}
                // 2. דריסת ה-onClick עם הפונקציה הממוזגת שלנו
                onClick={handleLocalClick}
                selected={selected}
                className={`option-item`}
                sx={{ cursor: 'pointer' }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', pointerEvents: 'none', width: '100%' }}>
                    {multiple ? (
                        <CheckBox input={{ value: selected, onChange: () => { } }} />
                    ) : (
                        <Radio checked={selected} color="thirdly6" />
                    )}
                    <Text className={`${showBlurred && 'blurred2'}`} width={fullWidth || width || 200}>
                        {getLabel?.(option) || option?.name}
                    </Text>
                </Box>
            </OptionStyles>
        </Tooltip>
    );
};

export default SelectOption

